import * as types from '@/store/modules/logistique/audit-mutation-type';
import genererCritereRecherche
  from '@/services/logistique/audit/genererObject/genererCritereRecherche';
import { RESET_STATE } from '@/store/mutation-type';
import { getAll } from '@/api/logistique/audit';

function initialState() {
  return {
    items: [],
    total: 0,
    auditCourant: null,
    critereRecherche: genererCritereRecherche(),
    lastPayload: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_AUDIT_COURANT](state, auditCourant) {
    state.auditCourant = auditCourant;
  },
  [types.SET_ITEMS](state, items) {
    state.items = items;
  },
  [types.SET_TOTAL](state, total) {
    state.total = total;
  },
  [types.SET_CRITERES](state, critereRecherche) {
    state.critereRecherche = critereRecherche;
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  setAuditCourant({ commit }, ot) {
    commit(types.SET_AUDIT_COURANT, ot);
  },
  async loadAudit({ commit }, param) {
    commit(types.SET_LAST_PAYLOAD, param);
    const response = await getAll(param);
    response.data.result.items.forEach((ordreTravail) => {
      ordreTravail.selected = false;
    });
    commit(types.SET_TOTAL, response.data.result.totalCount);
    commit(types.SET_ITEMS, response.data.result.items);
    return {};
  },
  setCritereRecherche({ commit }, critereRecherche) {
    commit(types.SET_CRITERES, critereRecherche);
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  total: state => {
    return state.total;
  },
  critereRecherche: state => {
    return state.critereRecherche;
  },
  auditCourant: state => {
    return state.auditCourant;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
